/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Day_SunInputs */

const cs_portals_day_sun = /** @type {(inputs: Portals_Day_SunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne`)
};

const en_portals_day_sun = /** @type {(inputs: Portals_Day_SunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sun`)
};

/**
* | output |
* | --- |
* | "Sun" |
*
* @param {Portals_Day_SunInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_day_sun = /** @type {((inputs?: Portals_Day_SunInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Day_SunInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_day_sun(inputs)
	return cs_portals_day_sun(inputs)
});